export default {"src":"/kelp/_next/static/media/hgeth.17156ab9.svg","height":108,"width":108,"blurWidth":0,"blurHeight":0};